import { Backdrop } from "../../components";
import { Typography } from "@mui/material";
import { MathJax } from "better-react-mathjax/esm";

const PreviewContent = () => {
  return (
    <>
      <MathJax>
        <Typography variant="h1">Generating Preview...</Typography>
        <Backdrop loading={true} />
      </MathJax>
    </>
  );
};

export { PreviewContent };
